import { Component, ElementRef, OnInit, ViewChild , ChangeDetectorRef} from '@angular/core';
import { ReferralService } from './../services/referral.service'
import {AddressService} from '../services/address.service'
import { debounceTime, distinctUntilChanged, map, skip, tap } from 'rxjs/operators';
import {AddReferralComponent}  from '../my-referral/add-referral/add-referral.component' ;
import {MyreferralViewDialogComponent} from './myreferral-view-dialog/myreferral-view-dialog.component' ;
import {MyReferralReasonDialogComponent} from './my-referral-reason-dialog/my-referral-reason-dialog.component'
import {MyReferralsDataSource} from '../datasource/myreferral.datasource'
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { fromEvent, merge, Subscription } from 'rxjs';
import { MatPaginator, MatDatepickerInputEvent, MatSelect } from '@angular/material';
import {FormBuilder , FormGroup , Validators} from '@angular/forms';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {DatePipe} from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router'
// import { MAT_DATE_LOCALE } from '@angular/material/core';





declare var $: any;

@Component({
  selector: 'app-my-referral',
  templateUrl: './my-referral.component.html',
  styleUrls: ['./my-referral.component.css'],
  providers: [DatePipe],

})
export class MyReferralComponent implements OnInit {


  dataSource : MyReferralsDataSource
  displayedColumns: string[] = ['companyname', 'contactperson', 'mobilenumber', 'emailid', 'details'];

  myReferrals: [];
  reasons: [];

  selectedReferral: {};
  countryList = []
  stateList = [];
  cityList = [];
  localityList = [];
  filterForm : FormGroup;
  current: Date = new Date();
  showError: boolean = false;
  Fromdate: Date;


  private subscriptions: Subscription[] = [];
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // @ViewChild('closebutton', {static:false}) closebutton;




  refferalFilterList = {
    from: 1,
    to: 10,
    search: '',
    statusIds: '',
    fromDate: '',
    toDate: '',
    action: ''
  };
  referralResult: any[];
  dashboardRecord: {};
  userDetail;
  currentUser: any;

  constructor(
    private router : Router,
    private dialog : MatDialog,
    private fb : FormBuilder,
    private referralService: ReferralService,
    private addressService : AddressService,
    private datePipe : DatePipe,
    private chRef : ChangeDetectorRef,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.dashboardRecord = {
      Applied: 0,
      Accepted: 0,
      Rejected: 0,
      Active: 0,
      Inactive: 0
    };
    this.currentUser = JSON.parse(localStorage.getItem('responseData'));
    this.userDetail = JSON.parse(localStorage.getItem('userDetail'));
    this.dataSource = new MyReferralsDataSource(this.referralService);
    const entitiesSubscription = this.dataSource.entitySubject.pipe(
      skip(1),
      distinctUntilChanged()
    ).subscribe(res => {
      this.referralResult = res;
    });
    this.subscriptions.push(entitiesSubscription);
    this.dataSource.loadMyreferral(this.refferalFilterList ,this.userDetail.referralCode);
    this.getReferralDashboard();
    this.createFilterForm();
  }

  ngAfterViewInit() {
    const searchSubscription = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => {
        this.paginator.pageIndex = 0;
        this.loadmyreferralspage();
      })
    )
      .subscribe();
    this.subscriptions.push(searchSubscription);
    const paginatorSubscriptions = merge(this.paginator.page).pipe(
      tap(() => this.loadmyreferralspage())
    )
      .subscribe();
    this.subscriptions.push(paginatorSubscriptions);
  }


  loadmyreferralspage() {
    if (this.paginator.pageIndex < 0 || this.paginator.pageIndex > (this.paginator.length / this.paginator.pageSize))
      return;
    this.refferalFilterList.from = ((this.paginator.pageIndex * this.paginator.pageSize) + 1);
    this.refferalFilterList.to = ((this.paginator.pageIndex + 1) * this.paginator.pageSize);

    this.refferalFilterList.search = this.searchInput.nativeElement.value;
    this.dataSource.loadMyreferral(this.refferalFilterList ,this.userDetail.referralCode);
    this.chRef.detectChanges();
    
  }

  createFilterForm(){
    this.filterForm = this.fb.group({
      // paymentStatusId:[''],
      FromDate:[''],
      ToDate : [''],
    });
  }

  showReasons(myReferralId) {
    $('#reasons').modal({
      show: 'false'
    });
    this.referralService.getReasons(myReferralId).subscribe(response => {
      this.reasons = response['data'];
    });
  }

  getLocalityList(CityId) {
    this.addressService.getLocality(CityId)
      .pipe(map(res => {
        if (res) {
          this.localityList = res;
        }
      }))
      .subscribe();
  }

  showDetails(detail) {
    this.selectedReferral = detail;
    $('#details').modal({
      show: 'false'
    });
  }

  showAddRefferalForm() {
    const dialogRef = this.dialog.open(AddReferralComponent, { width: '900px'});
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.loadmyreferralspage();
      this.toastr.success('Referral Added Successfully');
    });
   

  }


  getReferralDashboard() {
    this.referralService.getReferralDashboard()
    .pipe(map(response => {
      if(response['Status'] == 200) {
        this.dashboardRecord = response['data'];
      }
    }))
    .subscribe();
  }

  view(element){
    const dialogRef = this.dialog.open(MyreferralViewDialogComponent, { data: { element: element }, width: '900px' });
  }

  viewReasons(element) {
    var params = {
      element: element
    };
    const dialogRef = this.dialog.open(MyReferralReasonDialogComponent, { data: params , width: '600px' });
  }

  restrict(event: MatDatepickerInputEvent<Date>) {
		// this.Fromdate = event.value;
		if (this.filterForm.controls['FromDate'].touched) {
			this.filterForm.controls['ToDate'].setValidators(Validators.required);
			this.filterForm.controls['ToDate'].updateValueAndValidity();
			this.showError = true;
		}

		if (this.filterForm.controls['ToDate'].value) {
			this.showError = false;
		}
	}

  applyFilter(){
      const filterControl = this.filterForm.controls;
      // this.refferalFilterList.statusIds = filterControl['statusIds'].value;
      this.refferalFilterList.fromDate =  this.datePipe.transform( filterControl['FromDate'].value, 'yyyy-MM-dd');
      this.refferalFilterList.toDate = this.datePipe.transform( filterControl['ToDate'].value, 'yyyy-MM-dd');
      this.dataSource.loadMyreferral(this.refferalFilterList,this.userDetail.referralCode);
    }

    clearFilter(){
      // this.refferalFilterList.statusIds = ''
      this.refferalFilterList.fromDate = ''
      this.refferalFilterList.toDate = ''
      this.dataSource.loadMyreferral(this.refferalFilterList,this.userDetail.referralCode);
      this.filterForm.reset();
    }

    signout(currentUser){
      localStorage.clear();
      console.log(currentUser);
      this.toastr.success('Sign Out Successfully');
      this.router.navigate(['']);

    }

}
